<template>
  <li class="dropdown_menu" :class="mainExamListCssObj">
    <a v-b-toggle.coursesCollapse>
      <b-icon-book-half class="mr-1"></b-icon-book-half>
      <span class="link-title menu_hide">คอร์สเรียน</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse id="coursesCollapse" :visible="false" accordion="accordion">
      <main-exam-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainExamCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import _ from "lodash";
import AuthMixin from "@/mixins/auth-mixin.js";
import CustomUserPermissionMixin from "@/mixins/custom-user-permission-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainExamCollapseMenu,
  },
  mixins: [AuthMixin, CustomUserPermissionMixin],
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      memberId: JSON.parse(localStorage.getItem("user")).id,
      isActive: false,
      collapseList: [],
    };
  },
  computed: {
    mainExamListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  mounted() {
    if (checkSubMenuAccess({ menu: "course-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการคอร์สเรียน",
        to: {
          name: "course.management.index",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "course-tag-mgmt" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "จัดการหมวดหมู่คอร์ส",
        to: {
          name: "tags.overview",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "course-video-process-status" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "สถานะการประมวลผลวิดีโอ",
        to: {
          name: "course.video-process-status",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "course-group-mgmt" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "จัดการกลุ่มคอร์ส",
        to: {
          name: "course-group.management.index",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "course-additional-mgmt" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "จัดการข้อมูลอื่นๆ",
        to: {
          name: "course.additional.management",
        },
      });
    }
  },
  methods: {
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
